import { render, staticRenderFns } from "./ITEquipmentAllocation.vue?vue&type=template&id=747ad038&scoped=true"
import script from "./ITEquipmentAllocation.vue?vue&type=script&lang=js"
export * from "./ITEquipmentAllocation.vue?vue&type=script&lang=js"
import style0 from "./ITEquipmentAllocation.vue?vue&type=style&index=0&id=747ad038&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747ad038",
  null
  
)

export default component.exports